import {
  DELIVERY_METHOD,
  TRANSFER_METHOD,
} from 'services/digital-delivery/types';
import { IInfinitePageParams, IInfinitePageResponse } from 'services/types';

export interface IProviderSalesChannelMutation {
  deliveryTypeId: DELIVERY_METHOD;
  transferMethodId: TRANSFER_METHOD;
  waitForAssetId: boolean;
  expectTimestamp: boolean;
  salesChannelId: string;
}
export interface IProviderSalesChannel extends IProviderSalesChannelMutation {
  name: string;
}

export interface IProviderMutation {
  name: string;
  salesChannels: IProviderSalesChannelMutation[];
}

export interface IProviderForm
  extends Omit<IProviderMutation, 'salesChannels'> {
  salesChannels: IProviderSalesChannel[];
}

export interface ICreateProvider extends IProviderMutation {}

export interface IUpdateProvider extends IProviderMutation {
  id: string;
}

export interface IProviderSalesChannelDeliveryMethodResponse {
  deliveryType: {
    id: DELIVERY_METHOD;
  };
  transferMethod: {
    id: TRANSFER_METHOD;
  };
  waitForAssetId: boolean;
  expectTimestamp: boolean;
}
export interface IProviderSalesChannelResponse {
  salesChannelId: string;
  name: string;
  deliveryMethod: IProviderSalesChannelDeliveryMethodResponse;
}

export interface IProviderResponse {
  id: string;
  name: string;
  isPredefined: boolean;
  salesChannels: IProviderSalesChannelResponse[];
}

export interface IProviderSearchParams extends IInfinitePageParams {}

export interface IProvidersInfiniteResponse
  extends IInfinitePageResponse<IProviderResponse> {}

//! CONNECTION TYPES

export interface IConnectionIdendificators {
  salesChannelId: string;
  providerId: string;
}

export interface ICreateProviderFtpConnection
  extends IConnectionIdendificators {
  serverAddress: string;
  serverFolder: string;
  login: string;
  password: string;
  portNumber: number | null;
}

export interface IUpdateProviderFtpConnection
  extends ICreateProviderFtpConnection {
  version: number;
}

export interface IProviderFtpConnectionResponse
  extends IUpdateProviderFtpConnection {
  id: string;
  isPredefined: boolean;
  connectionStatusId: CONNECTION_STATUS | null;
  healthCheckDate: string | null;
}

export interface ICreateProviderSftpConnection
  extends IConnectionIdendificators {
  serverAddress: string;
  login: string;
  password: string;
  portNumber: number | null;
  keyPrint: string;
  serverFolder: string;
  completedServerFolder: string;
  keyPassphrase: string;
  keyPath: string;
  sshHostKeyPolicyId: number | null;
  preserveTimestamp: boolean;
  serviceAccepted: boolean;
}
export interface IUpdateProviderSftpConnection
  extends ICreateProviderSftpConnection {
  version: number;
}

export interface IProviderSftpConnectionResponse
  extends IUpdateProviderSftpConnection {
  id: string;
  isPredefined: boolean;
  connectionStatusId: CONNECTION_STATUS | null;
  healthCheckDate: string | null;
}

export interface ICreateProviderBlobConnection
  extends IConnectionIdendificators {
  accountName: string;
  containerName: string;
  blobMainPath: string;
  accountKey: string;
  endpointSuffix: string;
  defaultEndpointsProtocolId: number;
  serverFolder: string;
  completedServerFolder: string;
}

export interface IUpdateProviderBlobConnection
  extends ICreateProviderBlobConnection {
  version: number;
}

export interface IProviderBlobConnectionResponse
  extends IUpdateProviderBlobConnection {
  id: string;
  isPredefined: boolean;
  connectionStatusId: CONNECTION_STATUS | null;
  healthCheckDate: string | null;
}

export enum CONNECTION_STATUS {
  waiting = 1,
  ok = 2,
  timeout = 3,
  error = 4,
}

export enum WEB_PROTOCOL {
  HTTP = 1,
  HTTPS = 2,
}
